// extracted by mini-css-extract-plugin
export default {"container":"xr-z","brandName":"yr-z","productName":"zr-z","productNamePdpEnhancements":"Ar-z","breakLongProductName":"Br-z"};